import { api } from "boot/axios";

export const winners = async (_, data) => {
  try {
    const resp = await api.get(`/admin/trivias/${data}/winners/`);
    return Promise.resolve(resp.data);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};


export const list = async () => {
  try {
    const resp = await api.get(`/admin/trivias/?limit=200`);
    return Promise.resolve(resp.data);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};
